export type LoanTextMapType = Record<number, string>;

export const loanTextMap: LoanTextMapType = {
  0: 'loan.auto',
  2: 'loan.other',
  3: 'loan.factoring',
  4: 'loan.personal',
  5: 'loan.personalFinancing'
};

export const getLoanLabel = (customerId: number, t: (key: string) => string): string => {
  const key = loanTextMap[customerId];
  return key ? t(key) : t('loan.obsolete');
};
